__webpack_require__.p = "https://obe.usk.ac.id/";